import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bootstrap-members-athletes',
  templateUrl: './bootstrap-members-athletes.component.html',
  styleUrls: ['./bootstrap-members-athletes.component.scss']
})
export class BootstrapMembersAthletesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
